import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PasswordInputComponent),
    multi: true,
  }],
})
export class PasswordInputComponent implements ControlValueAccessor {

  constructor(
    private _analytics: AnalyticsService
    ) {
  }

  hidePassword = true;
  value: string;

  // Public Methods
  // ------------------------------------------------------------------------------------

  togglePassword(): void {
    this._analytics.logButtonTap('signIn_viewPasswordToggle');
    this.hidePassword = !this.hidePassword;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouched = fn;
  }

  onChange(event): void {
    const newValue = event.target.value;
    this.value = newValue;
    this.propagateChange(this.value);
  }

  propagateChange = (_: any) => { };
  propagateTouched = (_: any) => { };

}
